/**
 * Clean this up along with platform_editor_ai_obj_sidebar_undo_redo_buttons
 */
import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import RedoIcon from '@atlaskit/icon/core/redo';
import UndoIcon from '@atlaskit/icon/core/undo';

import { useAIRovoButtonEnablement } from '@confluence/ai-floating-context-menu/entry-points/useAIRovoButtonEnablement';

export const UndoButton = ({ canUndo, undo }: { canUndo: boolean; undo: () => boolean }) => {
	const isRovoButtonEnabled = useAIRovoButtonEnablement();

	return (
		<IconButton
			icon={UndoIcon}
			appearance="subtle"
			label=""
			testId="sidebar-undo-button"
			shape={isRovoButtonEnabled ? 'default' : 'circle'}
			onClick={() => {
				undo();
			}}
			tooltip={{
				position: 'left',
			}}
			isDisabled={!canUndo}
		/>
	);
};

export const RedoButton = ({ canRedo, redo }: { canRedo: boolean; redo: () => boolean }) => {
	const isRovoButtonEnabled = useAIRovoButtonEnablement();

	return (
		<IconButton
			icon={RedoIcon}
			appearance="subtle"
			label=""
			testId="sidebar-redo-button"
			shape={isRovoButtonEnabled ? 'default' : 'circle'}
			onClick={() => {
				redo();
			}}
			tooltip={{
				position: 'left',
			}}
			isDisabled={!canRedo}
		/>
	);
};
